<mat-form-field appearance="outline" class="chat-input-field">
  <div class="textarea-container">
    <textarea
      matInput
      #userInput
      class="chat-input"
      [placeholder]="'chat.askAQuestion' | xTranslate"
      rows="3"
      autocomplete="no-autofill"
      [ngModel]="message"
      (ngModelChange)="onMessageChange($event)"
      (keydown.enter)="isResponseInProgress ? $event.preventDefault() : send()"
    ></textarea>
    <div class="chat-input-buttons">
      <div
        class="view-all-prompts"
        [class.disabled]="isResponseInProgress"
        *ngIf="true; else noPrompts"
        (click)="isResponseInProgress ? $event.stopPropagation() : showPromptsPanel()"
      >
        <mat-icon svgIcon="magic"></mat-icon>
        <a href="javascript:void()">{{ 'chat.viewAllPrompts' | xTranslate }}</a>
      </div>
      <ng-template #noPrompts>
        <span style="visibility: hidden">Placeholder</span>
      </ng-template>
      <div
        class="send-button"
        [class.disabled]="!userInput.value || isResponseInProgress"
        (click)="!userInput.value ? $event.stopPropagation() : send()"
      >
        <mat-icon (click)="send()" svgIcon="send-icon"></mat-icon>
      </div>
    </div>
  </div>
</mat-form-field>
